import { Loader2 } from 'lucide-react';

/**
 * Reusable loading indicator with consistent styling across the app.
 * Respects prefers-reduced-motion for accessibility.
 */
export default function LoadingSpinner({ message = 'Cargando...', size = 'md' }) {
  const sizeClasses = { sm: 'w-5 h-5', md: 'w-8 h-8', lg: 'w-12 h-12' };

  return (
    <div
      className="flex flex-col items-center justify-center gap-3 py-12"
      role="status"
      aria-live="polite"
      aria-label={message}
    >
      <Loader2
        className={`${sizeClasses[size]} animate-spin`}
        style={{ color: 'var(--primary-color)' }}
        aria-hidden="true"
      />
      <span className="text-sm font-medium" style={{ color: 'var(--text-secondary)' }}>{message}</span>
    </div>
  );
}
